import Vue from "vue";
import VueI18n from "vue-i18n";
import {
  defaultLocale,
  LOCALE_STORAGE_KEY,
  localeList,
} from "./localeConfig";
import { loadLocaleMessages, markLocaleLoaded } from "./loadLocale";

import zh from "@/locales/zh.json";
import zhHelpQa from "@/locales/help-qa/zh.json";
import zhTutorialQa from "@/locales/tutorial-qa/zh.json";

function mergeLocaleChunks(base, helpQa, tutorialQa) {
  return {
    ...base,
    help: {
      ...(base.help || {}),
      ...(helpQa.help || {}),
    },
    tutorial: {
      ...(base.tutorial || {}),
      ...(tutorialQa.tutorial || {}),
    },
  };
}

Vue.use(VueI18n);

const supportedLocales = localeList.map((item) => item.code);

function getSavedLocale() {
  const saved = localStorage.getItem(LOCALE_STORAGE_KEY);
  if (saved && supportedLocales.includes(saved)) {
    return saved;
  }
  return defaultLocale;
}

const initialLocale = getSavedLocale();

const i18n = new VueI18n({
  locale: initialLocale,
  fallbackLocale: defaultLocale,
  silentTranslationWarn: true,
  messages: {},
});

// 默认语言同步加载，其余语言按需懒加载
i18n.setLocaleMessage(
  defaultLocale,
  mergeLocaleChunks(zh, zhHelpQa, zhTutorialQa),
);
markLocaleLoaded(defaultLocale);

if (initialLocale !== defaultLocale) {
  loadLocaleMessages(initialLocale, i18n).then(() => {
    i18n.locale = initialLocale;
  });
}

export async function setLocale(locale) {
  if (!supportedLocales.includes(locale)) return;
  await loadLocaleMessages(locale, i18n);
  i18n.locale = locale;
  localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  document.documentElement.lang = locale;
  if (typeof window !== "undefined" && window.__VUE_I18N__) {
    window.__VUE_I18N__ = i18n;
  }
}

document.documentElement.lang = i18n.locale;

export default i18n;
